import { Grid } from "@mui/material";
import { LEAGUE_CONFIGS } from "src/config/leagueConfigs";

const getLeagueConfig = () => {
  const league = process.env.REACT_APP_LEAGUE?.toLowerCase();
  return LEAGUE_CONFIGS[league] || LEAGUE_CONFIGS.default;
};

const playerHeadshotUrl = (row, imageHash = "") => {
  const config = getLeagueConfig();
  const baseUrl = config.playerHeadshot(row.externalRef, row.teamExternalRef);
  return imageHash ? `${baseUrl}?${imageHash}` : baseUrl;
};

const teamLogoUrl = (row, imageHash = "") => {
  const config = getLeagueConfig();
  const logoRef = row.teamExternalRef || row.externalRef;
  const baseUrl = config.teamLogo(logoRef);
  return imageHash ? `${baseUrl}?${imageHash}` : baseUrl;
};

const playerFileName = (row) => {
  const config = getLeagueConfig();
  return config.playerFileName(row.externalRef, row.teamExternalRef);
};

const teamFileName = (row) => {
  const config = getLeagueConfig();
  const logoRef = row.teamExternalRef || row.externalRef;
  return config.teamFileName(logoRef);
};

export const getFilenameForUpload = (row) => {
  if (row.teamExternalRef) {
    return playerFileName(row);
  } else {
    return teamFileName(row);
  }
};

export const PlayerHeadshot = ({ row, imageHash }) => {
  console.log("Rendering PlayerHeadshot for row:", row);
  return (
    <>
      {row.teamExternalRef ? (
        <Grid container>
          <Grid item xs={6}>
            <img
              alt="headshot"
              style={{ width: 120 }}
              src={playerHeadshotUrl(row, imageHash)}
            />
          </Grid>
          <Grid item xs={6}>
            <img
              alt="team logo"
              style={{ width: 40 }}
              src={teamLogoUrl(row, imageHash)}
            />
          </Grid>
        </Grid>
      ) : (
        <img
          alt="team logo"
          style={{ width: 80 }}
          src={teamLogoUrl(row, imageHash)}
        />
      )}
    </>
  );
};

export default PlayerHeadshot;
